// extracted by mini-css-extract-plugin
module.exports = {"carrouselList":"CarrouselList_carrouselList__ah3q9","title":"CarrouselList_title__0ATLA"};